import React, { useState, useEffect } from 'react';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import GatewayManagement from './components/GatewayManagement';
import ReportNMI from './components/ReportNMI';
import FriendliesUS from './components/FriendliesUS';
import Jobs from './components/Jobs';
import CardHolders from './components/CardHolders';
import AutoFriendlies from './components/AutoFriendlies';
import AutoFriendliesSS from './components/AutoFriendliesSS';

function AppContent() {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState('reports');

  // Ensure activeTab is valid for current user role
  useEffect(() => {
    if (user) {
      if (activeTab === 'gateways' && user.role !== 'superadmin') {
        setActiveTab('reports');
      }
      if (activeTab === 'users' && user.role !== 'superadmin') {
        setActiveTab('reports');
      }
    }
  }, [user, activeTab]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-gray-600">Loading...</div>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <main className="flex-1 overflow-y-auto">
        {activeTab === 'reports' && <ReportNMI />}
        {activeTab === 'friendlies-us' && <FriendliesUS />}
        {activeTab === 'jobs' && <Jobs />}
        {activeTab === 'cardholders' && <CardHolders />}
        {activeTab === 'gateways' && user.role === 'superadmin' && <GatewayManagement />}
        {activeTab === 'auto-friendlies' && <AutoFriendlies />}
        {activeTab === 'auto-friendlies-ss' && <AutoFriendliesSS />}
      </main>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
